"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _inputOtp = require("input-otp");
var _Loading = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Loading"));
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _reactIntl = require("react-intl");
var _apiV = require("../../../../services/auth/apiV2");
var _errors = _interopRequireDefault(require("../../../../consts/errors"));
var _Slot = _interopRequireDefault(require("./Slot"));
var _events = require("../../consts/events");
var _context = require("../../../../services/log/context");
var _context2 = require("../../../../services/auth/context");
var _usePublishOtpCodeEntered = _interopRequireDefault(require("../../consts/events/business/usePublishOtpCodeEntered"));
var _usePublishOtpScreenDisplayed = _interopRequireDefault(require("../../consts/events/business/usePublishOtpScreenDisplayed"));
var _usePublishLoginFailed = _interopRequireDefault(require("../../consts/events/business/usePublishLoginFailed"));
var _usePublishLoginSuccessful = _interopRequireDefault(require("../../consts/events/business/usePublishLoginSuccessful"));
var _store = require("../../../../services/auth/api20/store");
var _jsxRuntime = require("react/jsx-runtime");
var _div;
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-array-index-key */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OTPForm = _ref => {
  let {
    otpTransactionId,
    onSignInFulfilled
  } = _ref;
  const [otpCode, setOtpCode] = (0, _react.useState)("");
  const [loading, setLoading] = (0, _react.useState)(false);
  const [error, setError] = (0, _react.useState)(null);
  const {
    onGetUserInfoAndLogin
  } = (0, _context2.useAuth)();
  const {
    log
  } = (0, _context.useLog)();
  const intl = (0, _reactIntl.useIntl)();
  const publishOtpCodeEntered = (0, _usePublishOtpCodeEntered.default)();
  const publishOtpScreenDisplayed = (0, _usePublishOtpScreenDisplayed.default)();
  const publishLoginFailed = (0, _usePublishLoginFailed.default)();
  const publishLoginSuccessful = (0, _usePublishLoginSuccessful.default)();
  const handleComplete = async () => {
    publishOtpCodeEntered("email_otp");
    setLoading(true);
    try {
      const response = await (0, _apiV.userOTPLogin)({
        otpTransactionId,
        otpCode
      });
      const {
        token
      } = response;
      await _store.store.login({
        accessToken: token.access_token,
        refreshToken: token.refresh_token
      });
      const state = await _store.store.getState();
      if (state === "loggedIn") {
        setLoading(false);
        publishLoginSuccessful("email_otp");
        await onGetUserInfoAndLogin({
          token: token.access_token,
          refreshToken: token.refresh_token
        });
        onSignInFulfilled();
      } else {
        await log(_events.LOGIN_STEP_FAILED, {
          operation: "otpLogin",
          error: "OTP RECEIVED INVALID TOKENS."
        });
        publishOtpScreenDisplayed("email_otp", "web", true);
        publishLoginFailed("email_otp");
        setLoading(false);
        setError(_errors.default.general);
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      await log(_events.LOGIN_STEP_FAILED, {
        operation: "otpVerify",
        error: error.message
      });
      publishOtpScreenDisplayed("email_otp", "web", true);
      publishLoginFailed("email_otp");
      setLoading(false);
      if (error.message.includes("INVALID_OTP") === true) {
        setError(_errors.default.invalidOTP);
      } else {
        setError(_errors.default.general);
      }
    }
  };
  if (loading) {
    return _div || (_div = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "w-full",
      "data-test": "MagicLogin-Loader",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.default, {
        type: "boxLoader"
      })
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
    className: "w-full",
    "data-test": "MagicLogin-OtpForm",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_inputOtp.OTPInput, {
      maxLength: 6,
      value: otpCode,
      onChange: setOtpCode,
      onComplete: handleComplete,
      containerClassName: "group w-full flex items-center justify-center has-[:disabled]:opacity-30 mb-[32px]",
      render: _ref2 => {
        let {
          slots
        } = _ref2;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex",
          children: slots.slice(0, 6).map((slot, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Slot.default, {
            ...slot
          }, index))
        });
      },
      "aria-label": intl.formatMessage({
        id: "account.verify_modal.enter_passcode"
      })
    }), error != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
      dataTest: "MagicLogin-ErrorAlert",
      type: "critical",
      icon: true,
      labelClose: intl.formatMessage({
        id: "orbit.button_close"
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        ...error
      })
    })]
  });
};
var _default = exports.default = OTPForm;